import * as React from 'react';

function SvgComponent(props) {
  return (
    <svg
      id="prefix__All_rounder"
      data-name="All rounder"
      xmlns="http://www.w3.org/2000/svg"
      width={29.965}
      height={33.398}
      {...props}>
      <defs>
        <style>{`.prefix__cls-1{fill:${props.fillPrimary}}`}</style>
      </defs>
      <path
        id="prefix__Path_5334"
        data-name="Path 5334"
        className="prefix__cls-1"
        d="M0 18.646a5.235 5.235 0 01.334-.406Q2.4 16.167 4.472 14.1a2.41 2.41 0 01.207-.161c-.182-.173-.337-.311-.483-.458a1.022 1.022 0 010-1.576Q9.96 6.137 15.729.37a1.023 1.023 0 011.577 0q1.256 1.252 2.508 2.508a1.021 1.021 0 010 1.576q-5.767 5.77-11.536 11.537a1.02 1.02 0 01-1.575 0c-.144-.143-.279-.295-.481-.51a1.24 1.24 0 01-.139.233q-2.075 2.076-4.154 4.149c-.119.119-.261.214-.392.321H1.3c-.273-.248-.553-.488-.816-.747-.174-.172-.323-.369-.484-.555z"
        transform="rotate(74 9.7 12.873)"
      />
      <g id="prefix__Group_1614" data-name="Group 1614" transform="translate(17.454 .988)">
        <g id="prefix__Group_1613" data-name="Group 1613">
          <path
            id="prefix__Path_5335"
            data-name="Path 5335"
            className="prefix__cls-1"
            d="M245.118 212.964c-.223.175-.431.345-.648.5a.215.215 0 01-.164.013 6.751 6.751 0 01-4.916-5.115 6.6 6.6 0 01.266-3.959.391.391 0 01.317-.291c.116-.022.229-.06.354-.093a1.65 1.65 0 00-.01.173.31.31 0 00.24.3.3.3 0 00.348-.125.5.5 0 00.088-.176c.06-.255.223-.323.472-.316a5.693 5.693 0 011.88.346 5.008 5.008 0 012.988 2.861 5.125 5.125 0 01-.593 5.151.191.191 0 01-.236.1 1.751 1.751 0 00-.3-.047.327.327 0 00-.176.628zm-2.758-2.035a1.162 1.162 0 00-.1-.231q-.385-.486-.781-.963a.319.319 0 00-.424-.062.3.3 0 00-.108.424c.271.357.553.708.855 1.04a.39.39 0 00.342.039c.09-.034.146-.164.215-.247zm-2.008-3.508c-.228 0-.4.165-.35.361.11.426.241.848.387 1.264a.3.3 0 00.409.149.321.321 0 00.182-.4q-.168-.566-.341-1.13a.308.308 0 00-.288-.244zm-.488-1.183h.014a2.924 2.924 0 000 .341.307.307 0 00.459.235.387.387 0 00.193-.359c.022-.328.048-.656.085-.983.029-.255-.057-.423-.257-.454s-.354.094-.391.347c-.041.29-.067.582-.104.873zm4.45 5.945c-.034-.045-.082-.16-.168-.212-.344-.2-.7-.392-1.052-.58a.316.316 0 00-.424.119.3.3 0 00.073.417c.375.222.757.434 1.149.624.198.096.421-.085.421-.367z"
            transform="translate(-236.26 -203.879)"
          />
          <path
            id="prefix__Path_5336"
            data-name="Path 5336"
            className="prefix__cls-1"
            d="M161.648 224.992c.334.159.508.07.588-.291a1.1 1.1 0 01.8-.854 7.553 7.553 0 004.66 9.316l.009.058c-.362.1-.72.217-1.088.285-.111.02-.251-.095-.373-.157-.361-.184-.5-.13-.63.246a5.229 5.229 0 01-3.965-8.6zm-.248 1.62h-.021c.044.386.081.774.137 1.158a.3.3 0 00.359.249.324.324 0 00.28-.341q-.047-.735-.1-1.469a.325.325 0 00-.65 0c-.011.139-.005.271-.005.403zm.878 2.2c-.31 0-.475.221-.377.451.2.462.409.917.629 1.368a.315.315 0 00.446.133.323.323 0 00.129-.435c-.2-.44-.4-.883-.614-1.316-.048-.095-.168-.157-.213-.198zm2.812 3.941a1.166 1.166 0 00-.136-.251c-.345-.349-.7-.692-1.049-1.035a.318.318 0 00-.453-.015.3.3 0 00-.035.437c.366.378.741.749 1.131 1.1a.374.374 0 00.329.018c.089-.034.142-.16.213-.251z"
            transform="translate(-160.412 -223.102)"
          />
        </g>
      </g>
      <g id="prefix__Group_2487" data-name="Group 2487" transform="translate(-227.035 -259.602)">
        <g id="prefix__Group_2481" data-name="Group 2481" transform="translate(0 78)">
          <rect
            id="prefix__Rectangle_918"
            data-name="Rectangle 918"
            className="prefix__cls-1"
            width={29}
            height={11}
            rx={5.5}
            transform="translate(228 203)"
          />
          <text
            id="prefix__A_R"
            data-name="A/R"
            transform="translate(243 212)"
            fill={props.fillSecondary}
            fontSize={10}
            fontFamily="ProximaNova-Bold,Proxima Nova"
            fontWeight={700}>
            <tspan x={-8.28} y={0}>
              {'A/R'}
            </tspan>
          </text>
        </g>
      </g>
    </svg>
  );
}

export default SvgComponent;
